import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import Button from '../Button';
import IconClose from '../icons/Close';
import IconNotificationsOutline from '../icons/NotificationsOutline';

const Notification = ({ startDate, onOpen, onClose, ...props }) => {
  const { t } = useTranslation('components');

  const handleOpen = e => {
    e.preventDefault();
    onOpen();
  };

  const handleClose = e => {
    e.preventDefault();
    onClose();
  };

  return (
    <div
      className="bg-blue-900 border border-slate-400 text-white m-8 pt-4 pb-6 pl-4 pr-16 rounded-lg relative"
      {...props}
    >
      <button
        type="button"
        className="absolute right-0 top-0 mr-4 mt-4 flex items-center text-blue-200 hover:text-blue-300"
        onClick={handleClose}
      >
        <IconClose size="5" />
      </button>
      <div className="flex">
        <IconNotificationsOutline size="8" className="text-blue-200 mt-2 mr-6" />
        <div>
          <h3 className="font-semibold text-lg">{t('SessionNotification.title')}</h3>
          <div className="mr-8">
            {t('SessionNotification.text', { time: format(startDate, 'HH:mm') })}
          </div>
          <Button kind="primary:ghost" className="bg-white mt-4" onClick={handleOpen}>
            {t('SessionNotification.button.join')}
          </Button>
        </div>
      </div>
    </div>
  );
};

Notification.propTypes = {
  startDate: PropTypes.string,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
};

Notification.defaultProps = {
  onOpen: () => {},
  onClose: () => {},
};

export default Notification;
